import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

export default function AlterarSenha({ profile, onClose }) {
  const [atual, setAtual]       = useState('');
  const [nova, setNova]         = useState('');
  const [confirma, setConfirma] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (nova.length < 8) { setError('A nova senha deve ter no mínimo 8 caracteres.'); return; }
    if (nova !== confirma) { setError('A confirmação não confere com a nova senha.'); return; }

    setLoading(true);

    // Verifica senha atual tentando fazer login novamente
    const { error: checkErr } = await supabase.auth.signInWithPassword({
      email: profile.email,
      password: atual,
    });
    if (checkErr) { setError('Senha atual incorreta.'); setLoading(false); return; }

    // Atualiza a senha
    const { error: updateErr } = await supabase.auth.updateUser({ password: nova });
    if (updateErr) { setError('Erro ao atualizar senha. Tente novamente.'); setLoading(false); return; }

    setSuccess(true);
    setLoading(false);
  };

  return (
    <div style={S.overlay}>
      <div style={S.modal}>
        <div style={S.header}>
          <div style={S.title}>Alterar senha</div>
          <button style={S.closeBtn} onClick={onClose}>✕</button>
        </div>

        {success ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={S.successIcon}>✓</div>
            <div style={S.successTitle}>Senha alterada!</div>
            <p style={S.hint}>Sua senha foi atualizada com sucesso.</p>
            <button style={S.btnPrimary} onClick={onClose}>Fechar</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={S.form}>
            <div style={S.field}>
              <label style={S.label}>Senha atual</label>
              <input type="password" value={atual} onChange={e => setAtual(e.target.value)}
                placeholder="••••••••" required style={S.input} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Nova senha</label>
              <input type="password" value={nova} onChange={e => setNova(e.target.value)}
                placeholder="Mínimo 8 caracteres" required style={S.input} />
            </div>
            <div style={S.field}>
              <label style={S.label}>Confirmar nova senha</label>
              <input type="password" value={confirma} onChange={e => setConfirma(e.target.value)}
                placeholder="Repita a nova senha" required style={S.input} />
            </div>
            {error && <div style={S.error}>{error}</div>}
            <div style={S.actions}>
              <button type="button" style={S.btnSecondary} onClick={onClose}>Cancelar</button>
              <button type="submit" style={S.btnPrimary} disabled={loading}>
                {loading ? 'Salvando...' : 'Salvar nova senha'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

const S = {
  overlay:      { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 },
  modal:        { background: '#fff', borderRadius: 12, width: '100%', maxWidth: 400, padding: '24px 28px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)' },
  header:       { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 },
  title:        { fontSize: 17, fontWeight: 600, color: '#1a1a18', fontFamily: '"DM Sans", sans-serif' },
  closeBtn:     { background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', color: '#aaa', padding: 4 },
  form:         { display: 'flex', flexDirection: 'column', gap: 14 },
  field:        { display: 'flex', flexDirection: 'column', gap: 5 },
  label:        { fontSize: 12, fontWeight: 500, color: '#555', fontFamily: '"DM Sans", sans-serif' },
  input:        { border: '0.5px solid #e0ddd6', borderRadius: 7, padding: '9px 12px', fontSize: 13, fontFamily: '"DM Sans", sans-serif', background: '#fafaf8', color: '#1a1a18', outline: 'none' },
  error:        { background: '#fef2f2', border: '0.5px solid #fca5a5', borderRadius: 7, padding: '9px 12px', fontSize: 13, color: '#b91c1c', fontFamily: '"DM Sans", sans-serif' },
  actions:      { display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 4 },
  btnPrimary:   { background: '#1a5c38', color: '#fff', border: 'none', borderRadius: 7, padding: '9px 20px', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif' },
  btnSecondary: { background: '#fff', color: '#555', border: '0.5px solid #e0ddd6', borderRadius: 7, padding: '9px 20px', fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: '"DM Sans", sans-serif' },
  successIcon:  { width: 48, height: 48, borderRadius: '50%', background: '#eaf3de', color: '#1a5c38', fontSize: 22, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px' },
  successTitle: { fontSize: 17, fontWeight: 600, color: '#1a1a18', fontFamily: '"DM Sans", sans-serif', marginBottom: 10 },
  hint:         { fontSize: 13, color: '#888', fontFamily: '"DM Sans", sans-serif', lineHeight: 1.6, marginBottom: 16 },
};
